import TemplateView from '../../../../../TemplateView'
import InputField from '../../../../../components/InputField'
import messageResource from '../../../../../messageResource'
import Button from '../../../../../components/Button'
import {promoEditorMode} from '../../../constants'
import {isEnter} from '../../../../../keyHandlers'

export default class PromoCodeEditor extends TemplateView {
    constructor({
        changePromoModeCallback = (mode) => {},
        changePromoCallback = () => {},
        applyPromoCallback = () => {},
        removePromoCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            changePromoModeCallback,
            changePromoCallback,
            applyPromoCallback,
            removePromoCallback,
        }

        this.state = {
            mode: '',
            promoCode: '',
            promoInvalid: false,
        }

        this.onStatePropertyChanged('mode', (mode) => {
            this.$applyPromo.toggle(mode === promoEditorMode.APPLY)
            this.$removePromo.toggle(mode === promoEditorMode.REMOVE)
            this.$enterPromo.toggle(mode === promoEditorMode.ENTER)
        })

        this.onStatePropertyChanged('promoCode', (promoCode) => {
            this.applyButton.setState({
                disabled: !promoCode,
            })
            if (this.promoInput.getValue() !== promoCode) {
                this.promoInput.setState({value: promoCode})
            }
        })

        this.onStatePropertyChanged('promoInvalid', (promoInvalid) => {
            this.$promoInvalidError.toggle(promoInvalid)
        })
    }

    templateHtml() {
        return '<div class="promoCodeEditor">' +
               '    <div class="applyPromo"><%=applyPromo%></div>' +
               '    <div class="removePromo"><%=removePromo%></div>' +
               '    <div class="enterPromo">' +
               '        <div class="promoInvalidError"><%=promoInvalid%></div>' +
               '        <div class="promoInput"/>' +
               '        <div class="applyButton"/>' +
               '        <div class="deleteIcon"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            applyPromo: 'licenses.purchase_lightbox.check.apply_promo',
            removePromo: 'licenses.purchase_lightbox.check.remove_promo',
            promoInvalid: 'licenses.purchase_lightbox.check.promo_code_invalid',
        }
    }

    afterRender() {
        this.$applyPromo = this.find('.applyPromo')
        this.$removePromo = this.find('.removePromo')
        this.$enterPromo = this.find('.enterPromo')
        this.$promoInvalidError = this.find('.promoInvalidError')

        this.$applyPromo.on('click', () => this.callbacks.changePromoModeCallback(promoEditorMode.ENTER))
        this.$removePromo.on('click', () => {
            this.callbacks.removePromoCallback()
            this.callbacks.changePromoModeCallback(promoEditorMode.APPLY)
        })

        this.promoInput = new InputField({
            onChange: (value) => this.callbacks.changePromoCallback(value.trim()),
            onKeyDown: (e) => {
                if (isEnter(e.keyCode)) {
                    this._handleApplyClick()
                }
            },
            placeholder: messageResource.getMessage('licenses.purchase_lightbox.check.promo_code'),
            maxLength: 64,
        }).init(this.find('.enterPromo .promoInput'))

        this.applyButton = new Button({
            additionalClass: 'apply',
            label: messageResource.getMessage('common.apply'),
            onClickCb: () => this._handleApplyClick(),
        }).init(this.find('.applyButton'))
        this.applyButton.setState({
            disabled: true,
        })

        this.find('.deleteIcon').on('click', () => {
            this.callbacks.changePromoModeCallback(promoEditorMode.APPLY)
            this.callbacks.changePromoCallback('')
        })
    }

    _handleApplyClick() {
        if (!!this.promoInput.getValue()) {
            this.callbacks.applyPromoCallback()
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/orderSummary/PromoCodeEditor.js